import { ControlledSelect } from '@@viewCommonComponents/controlled';
import { applySpec, compose, identity, inc, times, toString } from 'ramda';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';

const NUMBER_OF_TWIN_RANKS_OPTIONS = 8;

const TwinRanksSelect = ({
  form,
  rules,
  name,
  label,
  tooltip,
  disabled,
  isDisplayed = true,
  ...extraProps
}) => {
  if (isDisplayed === false) {
    return null;
  }
  const twinRanksOptions = times(
    compose(
      applySpec({
        value: identity,
        label: identity
      }),
      toString,
      inc
    ),
    NUMBER_OF_TWIN_RANKS_OPTIONS
  );

  return (
    <ControlledSelect
      name={name}
      label={label}
      tooltip={tooltip}
      form={form}
      options={twinRanksOptions}
      rules={isRequiredSelect(twinRanksOptions, rules)}
      disabled={disabled}
      {...extraProps}
    />
  );
};

export default TwinRanksSelect;
